import React from "react";

const SelectedOrderContext = React.createContext(null);


export default SelectedOrderContext;